import { ACTIVE_SERVER_ID } from 'mk/settings';

const FAQ_INDEX_ARTICLE_SLUG = `:articleSlug(faq|faq-index-[a-z-\\d]+)`;

export const faqUrl = '/faq/';
export const faqAskQuestionUrl = '/faq/form/';
export const faqIndexUrl = `/faq/${FAQ_INDEX_ARTICLE_SLUG}/`;
export const faqRootUrl = '/faq/faq';
export const faqOldHelpUrl = '/help/';

export const faqBuyerReportUrl = {
    201: '/faq/mam-podozrenie-na-podvod-v-bazari/',
    202: '/faq/mam-podezreni-na-podvod-v-bazaru/',
    207: '/faq/report-buyer-in-bazaar/',
}[ACTIVE_SERVER_ID];

export const faqOldBrowserUrl = {
    201: '/faq/ako-aktualizovat-internetovy-prehliadac/',
    202: '/faq/jak-aktualizovat-internetovy-prohlizec/',
    207: '/faq/howto-update-browser/',
}[ACTIVE_SERVER_ID];

export const faqXMLImportMoreInfo = {
    201: '/faq/je-mozny-import-inzeratov-cez-xml-feed-z-mojho-eshopu/',
    202: '/faq/je-mozny-import-inzeratu-pres-xml-feed-z-meho-e-shopu/',
    207: '',
}[ACTIVE_SERVER_ID];

export const faqPlanPlusProUrl = {
    201: '/faq/faq/#h-platene-baliky-plus-pro',
    202: '/faq/faq/#h-placene-baliky-plus-pro',
    207: '',
}[ACTIVE_SERVER_ID];
